module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "numberSelect"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dbb7542","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/numberSelect/src/numberSelect.vue
// module id = 529
// module chunks = 0